import { AssetStatus } from "@hydrologiq/gql-experience/graphql"
import { AssignmentStatus } from "@hydrologiq/gql/graphql"

/**
 * Returns the background hex colour for a given asset status.
 */
export function getAssetStatusColor(status: AssetStatus | null | undefined): string {
  switch (status) {
    case AssetStatus.Active:
    case AssetStatus.Deployed:
      return "#4ade80" // green
    case AssetStatus.Reserved:
      return "#b5e550"
    case AssetStatus.Servicing:
    case AssetStatus.Testing:
      return "#52d3d8"
    case AssetStatus.Filling:
    case AssetStatus.Standby:
      return "#f7d469"
    case AssetStatus.Outbound:
      return "#a4c8f0"
    case AssetStatus.Inbound:
    case AssetStatus.Startup:
      return "#52d3d8"
    case AssetStatus.DispatchReady:
      return "#74a8e2"
    case AssetStatus.DepotChecked:
      return "#50c878"
    case AssetStatus.Error:
      return "#ef4444" // red
    case AssetStatus.Unknown:
      return "#a1a1aa"
    default:
      return "#7fde9b" // available (default green)
  }
}

/**
 * Returns the text colour for a given asset status.
 * Most statuses use the default dark text; Error uses white for contrast on the red background.
 */
export function getAssetStatusTextColor(status: AssetStatus | null | undefined): string | undefined {
  switch (status) {
    case AssetStatus.Error:
      return "white"
    default:
      return undefined // fall through to default theme color
  }
}

/**
 * Returns the background hex colour for a given monitoring/assignment status.
 */
export function getMonitoringStatusColor(status: AssignmentStatus | null | undefined): string {
  switch (status) {
    case AssignmentStatus.Active:
      return "#4ade80" // green
    default:
      return "#d4d4d8" // gray
  }
}
